// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.list-content[data-v-e994045e]{\n    position: relative;\n    padding: 0 20px;\n    width:100%;\n    overflow-x: auto;\n    height: 200px;\n}\n@media (max-width: 992px){\n.list-mobile[data-v-e994045e] {\n    display: block;\n    height: 350px;\n}\n}\np.title[data-v-e994045e]{\n  padding-top: 8px;\n  font-size: 24px;\n  padding-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
